module.exports = __webpack_public_path__ + "img/assistant.4ab8092e.png";